"use strict";

exports.__esModule = true;
exports.HistoricalPartCountDeleteDialog = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Core = require("../../../Core");
var _icons = require("@blueprintjs/icons");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var PartCountDialog = (0, _styledComponents["default"])(_core.Dialog).withConfig({
  displayName: "HistoricalPartCountDeleteDialog__PartCountDialog",
  componentId: "sc-1yygf5p-0"
})([".", "{border-top:1px solid rgba(0,0,0,0.1);padding-top:1rem;}"], _core.Classes.DIALOG_FOOTER);
var HistoricalPartCountDeleteDialog = exports.HistoricalPartCountDeleteDialog = function HistoricalPartCountDeleteDialog(props) {
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var translator = (0, _react.useContext)(_Core.TranslatorContext);
  var show = props.show,
    onClickNoButton = props.onClickNoButton,
    onClickYesButton = props.onClickYesButton,
    closeButton = props.closeButton;
  var translate = translator.translate;
  return /*#__PURE__*/_react["default"].createElement(PartCountDialog, {
    icon: _icons.IconNames.TRASH,
    className: theme.bodyClassName,
    isOpen: show,
    onClose: closeButton,
    title: translate("HistoricalPartCountDeleteDialog.title", "Delete Part Count")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG_BODY
  }, /*#__PURE__*/_react["default"].createElement("p", null, translate("HistoricalPartCountDeleteDialog.info.label", "Are you sure that you want to delete this part count?"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG_FOOTER
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG_FOOTER_ACTIONS,
    style: {
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    style: {
      marginLeft: "0px"
    },
    intent: _core.Intent.SECONDARY,
    onClick: onClickNoButton,
    "data-testid": "HistoricalPartCountDeleteDialog.button.No"
  }, translate("HistoricalPartCountDeleteDialog.button.No", "No")), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    intent: _core.Intent.PRIMARY,
    onClick: onClickYesButton,
    "data-testid": "HistoricalPartCountDeleteDialog.button.Yes"
  }, translate("HistoricalPartCountDeleteDialog.button.Yes", "Yes")))));
};